/**
 * valがcount文字以上の場合、count文字で切って"..."を付与
 */
export function ellipsis(val, count) {
  if (val && val.length > count) {
    return val.slice(0, count) + '...';
  }
  return val;
}
